/* eslint-disable camelcase */
import React, { useContext } from 'react';

import { CustomerContext } from 'context/customer';

import { logMparticleEvent, mParticleCustomEvents, mParticleEventTypes } from 'helpers/mParticle';

import styles from './SavedAddresses.module.scss';

interface Address {
  id: number;
  place_formatted_address?: string;
  formatted_address: string;
  latitude?: number | string;
  longitude?: number | string;
}

type OnSelectAddress = (a: Address) => void;

interface SavedAddressesProps {
  onSelectAddress: OnSelectAddress;
  savedAddresses: Array<Address>;
  mparticleSource: string;
}

export default function SavedAddresses({
  onSelectAddress,
  savedAddresses,
  mparticleSource,
}: SavedAddressesProps) {
  const { user } = useContext(CustomerContext);
  const mparticleLocation =
    mparticleSource === 'homepage'
      ? 'saved_address_hero_search_bar'
      : 'saved_address_search_listing_modal';

  function handleonSelectAddress(address: Address) {
    onSelectAddress(address);
    if (address) {
      logMparticleEvent({
        eventName: mParticleCustomEvents.performLocationSearch,
        eventType: mParticleEventTypes.Other,
        attributes: {
          source: mparticleSource,
          location: mparticleLocation,
          searched_location: address.place_formatted_address,
          searched_latitude: address.latitude?.toString(),
          searched_longitude: address.longitude?.toString(),
          user_is_authenticated: !!user,
        },
      });
    }
  }

  return (
    <ul className={styles.addressList}>
      <p className={styles.heading}>Saved Addresses</p>
      {savedAddresses.slice(0, 3).map((address) => (
        <li key={address.id} data-testid="SavedAddress">
          <button
            className={styles.address}
            onClick={() => handleonSelectAddress(address)}
            type="button"
          >
            {address.formatted_address}
          </button>
        </li>
      ))}
    </ul>
  );
}
